import * as platform from 'platform';
import { find } from 'lodash';

const OSX_DL_L = "https://vleader-software.s3.amazonaws.com/transfer/1_28_2021/vLeader.zip";//"https://d2dlaai06rkmfw.cloudfront.net/installers/osx/vLeader.dmg";
const WIN_DL_L = "https://d2dlaai06rkmfw.cloudfront.net/installers/windows/vLeader-installer.exe";

// Determine if the platform signature matches windows/osx
// then return the correct launcher href
export function getDownloadLink() {
    const windowsMatches = [
        "windows", "win", "microsoft", "xp"
    ];

    const signatureToMatch:string = platform.os.toString().toLowerCase();

    const isOSX = find(windowsMatches, windowsBasedMatch => {
        return signatureToMatch.includes(windowsBasedMatch);
    }) === undefined;

    if (isOSX) {
        return OSX_DL_L;
    }

    return WIN_DL_L;
}

// Handle "downloading" the correct launcher
export function launchDownloadLink() {
    window.open(getDownloadLink(), "_blank");
}

export function launchWindowsDownload() {
    window.open(WIN_DL_L, "_blank");
}

export function launchOSXDownload() {
    window.open(OSX_DL_L, "_blank");
}
